import React from 'react'

const BannerLanding = (props) => (
    <section id="banner" className="style2 news-banner-wrapper">
        <div className="inner">
            <header className="major-alt">
                <h1>Portsmouth, UK</h1>
            </header>
            <div className="content">
                <p>Having been born and bred in Portsmouth, and having lived here for virtually
                my entire life, I feel that I’m well placed to know a thing or two about my home town!</p>
            </div>
        </div>
    </section>
)

export default BannerLanding



// WEBPACK FOOTER //
// ./src/components/BannerPortsmouth.js